import debounce from 'lodash.debounce';
import { CloseActiveMobileMenu } from '4-sections/MobileHeader/MobileHeader';

const CloseActiveMegaMenu = () => {
    const activeNavItems = document.querySelectorAll('.active-nav-item');
    activeNavItems.forEach(activeNavItem => {
        activeNavItem.classList.remove('active-nav-item');
    });
};

const DesktopMegaMenuHandler = () => {
    const MenuLinks = document.querySelectorAll('.dh-nav-item-link');

    MenuLinks.forEach(menuLink => {
        menuLink.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            const navItem = menuLink.parentElement;
            if (navItem) {
                if (navItem.classList.contains('active-nav-item')) {
                    navItem.classList.remove('active-nav-item');
                } else {
                    // close other
                    CloseActiveMegaMenu();
                    navItem.classList.add('active-nav-item');
                }
            }
        });
    });
};

const DesktopSecondaryHeaderOpened = () => {
    const activeHeader = document.querySelector('header[data-active-secondary-item]');
    const DesktopHeader = document.querySelector('.desktop-header');

    if (activeHeader) {
        const activeItemId = activeHeader.dataset.activeSecondaryItem;

        if (activeItemId) {
            const activeItemLink = activeHeader.querySelector(`#${activeItemId}`);
            if (activeItemLink) {
                const navItem = activeItemLink.closest('.dsh-nav-item');
                navItem.classList.add('active-dsh-nav-item');

                if (DesktopHeader && !DesktopHeader.classList.contains('expand-second-header')) {
                    DesktopHeader.classList.add('expand-second-header');
                }

                activeItemLink.classList.add('active-dsh-mega-menu-item-link');
            }
        }
    }
};

const MegaMenuCloseHandler = event => {
    const clickedElement = event.target;
    if (!clickedElement?.closest('.desktop-mega-menu')) {
        const activeNavItems = document.querySelectorAll('.active-nav-item');
        activeNavItems.forEach(activeNavItem => {
            activeNavItem.classList.remove('active-nav-item');
        });
    }
};

document.addEventListener('DOMContentLoaded', DesktopMegaMenuHandler);
document.addEventListener('DOMContentLoaded', DesktopSecondaryHeaderOpened);
document.addEventListener('click', MegaMenuCloseHandler);

const HEADER_FIXED_CLASS = 'header-sticky';
const HEADER_FIXED_SHOW_CLASS = 'header-sticky-show';
const HEADER_FIXED_HIDE_CLASS = 'header-sticky-hide';
const DEBOUNCE_VALUE = 10;

const HalfStickyHandler = () => {
    const el = document.querySelector('#header');
    let prevScrollY = window.pageYOffset;

    const hideFixedHeader = () => {
        if (!el.classList.contains(HEADER_FIXED_HIDE_CLASS)) {
            el.classList.remove(HEADER_FIXED_SHOW_CLASS);
            el.classList.add(HEADER_FIXED_CLASS, HEADER_FIXED_HIDE_CLASS);
            CloseActiveMegaMenu();
        }
    };

    const showFixedHeader = () => {
        if (!el.classList.contains(HEADER_FIXED_SHOW_CLASS)) {
            el.classList.remove(HEADER_FIXED_HIDE_CLASS);
            el.classList.add(HEADER_FIXED_CLASS, HEADER_FIXED_SHOW_CLASS);
        }
    };

    const cleanFixedHeader = () => el.classList.remove(
        HEADER_FIXED_CLASS, HEADER_FIXED_SHOW_CLASS, HEADER_FIXED_HIDE_CLASS
    );

    const applyFixedHeader = () => el.classList.add(HEADER_FIXED_CLASS);

    const windowScrollCheck = () => {
        const headerHeight = el?.offsetHeight;
        const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

        // if on top of the page
        if (currentScrollY <= headerHeight) {
            // If on top of the page, change back to absolute position
            // Depend on your needs position can be changed
            if (currentScrollY === 0) {
                cleanFixedHeader();
            }
        // If more than header height and scroll up
        } else if (currentScrollY < prevScrollY) {
            if (prevScrollY - currentScrollY < 200) {
                showFixedHeader();
            }
            // showFixedHeader();
        // If more than header height and scroll down
        } else if (currentScrollY !== prevScrollY) {
            const isFixed = el.classList.contains(HEADER_FIXED_CLASS);
            const isFixedShow = el.classList.contains(HEADER_FIXED_SHOW_CLASS);
            const isFixedHide = el.classList.contains(HEADER_FIXED_HIDE_CLASS);

            // if after header is shown on fixed state
            if (isFixed && isFixedShow) {
                hideFixedHeader();
            // if from absolute then apply fixed position
            } else if (!isFixed && !isFixedHide) {
                applyFixedHeader();
                CloseActiveMegaMenu();
            }

            CloseActiveMobileMenu();
        }

        prevScrollY = currentScrollY;
    };

    windowScrollCheck();

    window.addEventListener('resize', debounce(windowScrollCheck, DEBOUNCE_VALUE));
    window.addEventListener('scroll', debounce(windowScrollCheck, DEBOUNCE_VALUE));
};

document.addEventListener('DOMContentLoaded', HalfStickyHandler);

// eslint-disable-next-line import/prefer-default-export
export const CalculatePadding = () => {
    const headerEl = document.querySelector('header#header');
    const alertEl = document.querySelector('.alert-banner');
    const pageContent = document.querySelector('div#page-content');
    let modifier = 0;
    let headerTopModifier = 0;

    if (headerEl) {
        modifier = headerEl.clientHeight;

        if (alertEl) {
            headerTopModifier = alertEl.clientHeight;
            headerEl.setAttribute('style', `--top-modifier: ${headerTopModifier}px; --hide-modifier: ${headerTopModifier + modifier}px;`);
        }
    }

    if (pageContent) {
        pageContent.setAttribute('style', `margin-top: ${modifier}px;`);
    }
};

const StartCalculatePadding = () => {
    CalculatePadding();
    window.addEventListener('resize', CalculatePadding);
};

document.addEventListener('DOMContentLoaded', () => { setTimeout(StartCalculatePadding, 1); });
